import { useIntl } from 'react-intl';
import { useLocaleStore, SUPPORTED_LOCALES, type SupportedLocale } from '@/i18n';

/**
 * Compact locale selector rendered in the TopBar.
 * Uses a <select> for simplicity — upgradeable to a dropdown menu
 * when the design system adds a Menu primitive.
 */
export function LocaleSwitcher() {
  const intl = useIntl();
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);

  return (
    <select
      value={locale}
      onChange={(e) => setLocale(e.target.value as SupportedLocale)}
      aria-label="언어 선택"
      className="kuun-topbar-ctl"
      // 2026-10-21 오너 — 옆 버튼들(패치노트 34px)과 키를 맞춘다(종전 28px 로 혼자 작았다).
      style={{
        height: 34,
        padding: '0 8px',
        fontSize: 13,
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-sm)',
        background: 'var(--bg-surface)',
        color: 'var(--fg-default)',
        cursor: 'pointer',
      }}
    >
      {SUPPORTED_LOCALES.map((loc) => (
        <option key={loc} value={loc}>
          {intl.formatMessage({ id: `locale.${loc}` })}
        </option>
      ))}
    </select>
  );
}
